const DELIVERY_LOG_STATUS = {
  ALL: 'all',
  SUCCESS: 'success',
  FAILURE: 'failure',
};

export default DELIVERY_LOG_STATUS;
